import React from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Link } from "react-router-dom";
import { AppButton } from "../ui";

const HomeExperienceCard = ({ card, onOpen }) => {
  const environmentCount = Array.isArray(card.environmentNames) ? card.environmentNames.length : 0;

  const handleCardKeyDown = (event) => {
    if (event.currentTarget !== event.target) {
      return;
    }

    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onOpen(card);
    }
  };

  return (
    <article
      className="homeExperienceCard"
      role="button"
      tabIndex={0}
      aria-label={`Open details for ${card.title}`}
      onClick={() => onOpen(card)}
      onKeyDown={handleCardKeyDown}
    >
      <div className="homeExperienceCard__media">
        {card.thumbnailUrl ? (
          <img
            className="homeExperienceCard__image"
            src={card.thumbnailUrl}
            alt={`${card.title} thumbnail`}
            loading="lazy"
          />
        ) : (
          <div className="homeExperienceCard__fallback">
            <span>{card.title}</span>
          </div>
        )}
      </div>

      <div className="homeExperienceCard__body">
        <h3 className="homeExperienceCard__title">{card.title}</h3>
        <p className="homeExperienceCard__description">{card.description}</p>
        <p className="homeExperienceCard__meta">
          <span>Typical Session Length: {card.averageLength || "15 min"}</span>
          {environmentCount > 0 && <span>Environments: {environmentCount}</span>}
          {/* Topics hidden for now. */}
        </p>
        <AppButton
          component={Link}
          to={card.viewerUrl}
          kind="primary"
          startIcon={<VisibilityOutlinedIcon />}
          className="homeExperienceCard__launch"
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          Preview
        </AppButton>
      </div>
    </article>
  );
};

export default HomeExperienceCard;
